import { render, staticRenderFns } from "./DetailAdd.vue?vue&type=template&id=7c8a9f9d&scoped=true&"
import script from "./DetailAdd.vue?vue&type=script&lang=js&"
export * from "./DetailAdd.vue?vue&type=script&lang=js&"
import style0 from "./DetailAdd.vue?vue&type=style&index=0&id=7c8a9f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a9f9d",
  null
  
)

export default component.exports